module.exports = __webpack_public_path__ + "static/media/commerical-1.08159caf.jpg";